<h4>{{'formConfig.editor.editMode'|translate}}</h4>
<section class="edit-mode">
    <c-flip-switch id="form-config-design-mode" on="{{'formConfig.editor.editMode.design'|translate}}" off="{{'formConfig.editor.editMode.run'|translate}}" state="editor.designMode" />
</section>
<div style="float: none; display: inline-block">
    <section ng-if="editor.showRoleSwitch" class="edit-role-section">
        <h4>{{'formConfig.editor.role'|translate}}</h4>
        <section class="edit-role" c-select options="editor.roles" selected-option="editor.role"></section>
    </section>
    <section class="edit-language-section">
        <h4>{{'formConfig.editor.language'|translate}}</h4>
        <section class="edit-language" c-select options="editor.languages" selected-option="editor.language"></section>
    </section>
</div>
<section ng-if="editor.numberOfPages > 1" class="edit-page-section">
    <h4>{{'formConfig.editor.page'|translate}}</h4>
    <div class="page-control">
        <div ng-click="previousPage()" class="left"><i class="fa fa-chevron-circle-left" ng-class="{'disabled': editor.currentPage <= 1}"></i></div>
        <section c-select options="pages" selected-option="page"></section>
        <div ng-click="nextPage()" class="right"><i class="fa fa-chevron-circle-right" ng-class="{'disabled': editor.currentPage >= editor.numberOfPages}"></i></div>
    </div>
</section>
<section class="edit-properties" ng-show="editor.designMode && (isFieldSelected || isSectionSelected)">
    <h4>{{'formConfig.editor.properties'|translate}}</h4>
    <div ng-show="isSectionControlled">({{sectionControllerName}})</div>
    <table id="properties" class="property-list"></table>
</section>
<section class="edit-collapse" ng-show="editor.designMode && isSectionSelected">
    <h4>{{'formConfig.editor.collapse'|translate}}</h4>
    <table id="collapse" class="property-list"></table>
</section>
<section class="edit-transparency" ng-show="editor.designMode && isSectionSelected && isSectionVisible && isTransparencyVisible">
    <h4>{{'formConfig.editor.transparency'|translate}}</h4>
    <table id="transparency" class="property-list"></table>
</section>
<section class="edit-editors" ng-show="editor.designMode && isSectionSelected && isSectionVisible && isEditorConfigurationVisible">
    <h4>{{'formConfig.editor.editorConfiguration'|translate}}</h4>
    <table id="editor-configuration" class="property-list"></table>
</section>
<section class="edit-field-check" ng-show="editor.designMode && isValidationEditable && (isSectionVisible || hasValidationRules)">
    <h4>{{'formConfig.editor.field.check'|translate}}</h4>
    <div ng-show="isFieldSelected && !hasFieldRule">({{'formConfig.editor.field.check.inherited'|translate}})</div>
    <table id="check" class="property-list"></table>
    <section class="edit-field-check-reset" ng-show="hasFieldRule"><input type="button" value="{{'formConfig.editor.field.check.reset'|translate}}" ng-click="editor.resetFieldCheck()" /></section>
    <section class="edit-field-rules" ng-show="isFieldValidated && hasValidationRules">
        <h4>{{'formConfig.editor.field.rules'|translate}}</h4>
        <table id="rules" class="property-list"></table>
    </section>
</section>
<section class="edit-controller" ng-show="editor.designMode && isFieldController">
    <h4>{{'formConfig.editor.controller'|translate}}</h4>
    <table id="controller" class="property-list"></table>
</section>
<section class="edit-controller" ng-show="editor.designMode && isActivityController">
    <h4>{{'formConfig.editor.activityController'|translate}}</h4>
    <table id="activity" class="property-list"></table>
</section>
<section class="edit-controller" ng-show="editor.designMode && hasOptionNotifications">
    <h4>{{'formConfig.editor.optionNotification'|translate}}</h4>
    <div ng-show="isFieldSelected && !hasFieldRule">({{'formConfig.editor.optionNotification.description'|translate}})</div>
    <table id="notifications" class="property-list"></table>
</section>
<section class="edit-controller" ng-show="editor.designMode && isRecipientController">
    <h4>{{'formConfig.editor.recipients'|translate}}</h4>
    <div ng-show="isFieldSelected && !hasFieldRule">({{'formConfig.editor.recipient.description'|translate}})</div>
    <table id="recipients" class="property-list"></table>
</section>
<section class="edit-lookup-mappings" ng-show="editor.designMode && isLookupField">
    <h4>{{'formConfig.editor.lookup.mappings'|translate}}</h4>
    <table id="lookup-mappings" class="property-list"></table>
    <div class="empty" ng-show="!lookupFieldHasProperties">{{'formConfig.editor.lookup.mappings.empty'|translate}}</div>
</section>
<section class="edit-lookup-filters" ng-show="editor.designMode && isLookupField">
    <h4>{{'formConfig.editor.lookup.filters'|translate}}</h4>
    <table id="lookup-filters" class="property-list"></table>
    <div class="empty" ng-show="!lookupFieldHasFilters">{{'formConfig.editor.lookup.filters.empty'|translate}}</div>
</section>
<section class="edit-lookup-translations" ng-show="editor.designMode && isLookupField">
    <h4>{{'formConfig.editor.lookup.translations'|translate}}</h4>
    <table id="lookup-translations" class="property-list"></table>
    <div class="empty" ng-show="!lookupFieldHasIdentityProperties">{{'formConfig.editor.lookup.translations.empty'|translate}}</div>
</section>
